module.exports = __webpack_public_path__ + "img/jiaoshiduan.61873436.png";